export default __webpack_public_path__ + "static/Inter-Variable-cff273b49c596af6fd7492781807d104.ttf";